import React from 'react'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { constants } from 'helpers'
import { useApplePayButton, useApplePayPaymentMethodButton, useInquire } from 'modules/payment'

import { Icon } from 'components/dataDisplay'

import ExpressCheckoutButton from '../ExpressCheckoutButton/ExpressCheckoutButton'


const ApplePayBuyButton: React.FC = () => {
  const { submitApplePay, isReady, isProcessing } = useApplePayButton()

  return (
    <ExpressCheckoutButton
      disabled={!isReady || isProcessing}
      loading={!isReady}
      onClick={submitApplePay}
      data-testid="applePayButton"
    >
      <Icon name="other/apple-pay" />
    </ExpressCheckoutButton>
  )
}

// Card update or add new Payment Method
const ApplePayPaymentMethodButton: React.FC = () => {
  const { submitApplePay, isReady, isProcessing } = useApplePayPaymentMethodButton()

  return (
    <ExpressCheckoutButton
      disabled={!isReady || isProcessing}
      loading={!isReady}
      onClick={submitApplePay}
      data-testid="applePayButton"
    >
      <Icon name="other/apple-pay" />
    </ExpressCheckoutButton>
  )
}

const ApplePayButton: React.FC = () => {
  const inquireContext = useInquire()
  const isApplePayPaymentMethodEnabled = useFeatureIsOn(constants.features.applePayPaymentMethod)

  if (Boolean(inquireContext)) {
    return <ApplePayBuyButton />
  }

  if (isApplePayPaymentMethodEnabled) {
    return <ApplePayPaymentMethodButton />
  }

  return null
}


export default ApplePayButton
